<p><img src="images/banners/{{ domain }}.png" class="w-full"></p>
